import { Flex } from '@radix-ui/themes';

export const Card = ({
  children,
  gap,
  direction,
  backgroundColor = 'white',
  padding = '8',
  width,
}: {
  children: React.ReactNode;
  gap?: string;
  direction?: 'row' | 'column' | undefined;
  backgroundColor?: string;
  padding?: string;
  width?: string;
}) => {
  const style =
    backgroundColor === 'primary'
      ? { backgroundColor: 'var(--primary-color,#3463F8)' }
      : { backgroundColor };

  return (
    <Flex className="relative" width={width}>
      <Flex
        className="absolute inset-0 border border-gray-200 rounded-md shadow-[0_8px_24px_rgba(0,0,0,0.12)]
        [clip-path:polygon(40px_0,100%_0,100%_calc(100%_-_40px),calc(100%_-_40px)_100%,0_100%,0_40px)]"
      />

      <Flex
        direction={direction}
        gap={gap}
        style={style}
        width={width}
        className={`flex-1 relative p-${padding} rounded-md
        [clip-path:polygon(40px_0,100%_0,100%_calc(100%_-_40px),calc(100%_-_40px)_100%,0_100%,0_40px)]`}
      >
        {children}
      </Flex>

      <Flex
        className="absolute -z-10 inset-0 bg-gray-100 translate-x-1 translate-y-1
        [clip-path:polygon(40px_0,100%_0,100%_calc(100%_-_40px),calc(100%_-_40px)_100%,0_100%,0_40px)]"
      />

      <Flex
        className="absolute -z-10 inset-0 bg-gray-100 -translate-x-0.5 -translate-y-0.5
        [clip-path:polygon(40px_0,100%_0,100%_calc(100%_-_40px),calc(100%_-_40px)_100%,0_100%,0_40px)]"
      />
    </Flex>
  );
};

Card.displayName = 'Card';

export default Card;
